export enum CeveCutStatus {
  NEW = 'NEW',
  SAVED = 'SAVED',
  CLOSED = 'CLOSED',
  INCOMPLETESIGNED = 'INCOMPLETESIGNED',
  PUBLISHED = 'PUBLISHED',
  LAPSED = 'LAPSED'
}

export enum CutPtStatus {
  NEW = 'NEW',
  INVENTORY = 'INVENTORY',
  COUNTING = 'COUNTING',
  PAUSED = 'PAUSED',
  AUDITED = 'AUDITED',
  SAVED = 'SAVED',
  CLOSED = 'CLOSED',
  SIGNING = 'SIGNING',
  RECOUNT = 'RECOUNT',
  PUBLISHED = 'PUBLISHED',
  LAPSED = 'LAPSED',
  REOPEN = 'REOPEN'
}
